import { useState, useEffect } from 'react';
import { getToolData, getCategoryData } from '../data/api';

/**
 * Custom hook for fetching tool or category data
 * @param {string} type - The type of data to fetch ('tool' or 'category')
 * @param {string} category - The category slug
 * @param {string} subcategory - The subcategory slug (optional)
 * @param {string} toolId - The tool ID (optional, required if type is 'tool')
 * @returns {Object} The data and loading state
 */
const useToolData = (type, category, subcategory, toolId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        let result;
        if (type === 'tool' && toolId) {
          result = await getToolData(category, subcategory, toolId);
        } else if (type === 'category') {
          result = await getCategoryData(category, subcategory);
        } else {
          throw new Error('Invalid parameters provided to useToolData');
        }
        
        if (!result) {
          throw new Error('Resource not found');
        }
        
        setData(result);
        setError(null);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message || 'An error occurred');
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [type, category, subcategory, toolId]);
  
  return { data, loading, error };
};

export default useToolData; 